// @ts-nocheck
import { Breadcrumb, BreadcrumbItem, Col, Container, GridItem, GridItemText, GridItemTextWrapper, GridList, GridRow, ResponsiveImage, Row } from 'design-react-kit';
import React, { useState, useEffect, useContext } from 'react';
import authApiService from 'pa_kit/services/api';
import { WidgetClass } from 'apps/pages/models/widget';
import WidgetTags from 'apps/tags/components/widget_tags';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import env from '../../../env';
import { Helmet } from "react-helmet-async";
import { ActaAuthContext } from "pa_kit/auth";

const PageTags = (props) => {

    const auth = useContext(ActaAuthContext);

    const organization = auth.organization;

    const [ stickyTags, setStickyTags ] = useState();

    const [ widgetTags ] = useState(new WidgetClass({
        name: "AllTagsListContent",
        class: "all-tags-list-content",
        type: "tags",
        list_style: "cards"
    }));

    const fetchTagList = async() => {
        const tagListData = await authApiService.getTags();
        const stickyTagsData = tagListData.filter(tag => tag.is_sticky === true);
        setStickyTags(stickyTagsData);
    }

    useEffect(() => {
        fetchTagList();
    }, []);

    return <>
        <Helmet>
            <title>{'Argomenti | ' + organization.name}</title>
            <meta name="description" content="Gli argomenti rispondono a un'esigenza di organizzazione dei contenuti per temi e rappresentano le principali categorie di contenuti, informazioni e documenti." />
        </Helmet>
        <Container fluid className="p-0 tags-main-wrapper">
            <Container className="pt-5 px-3">
                <Row>
                    <Col>
                        <Breadcrumb>
                            <BreadcrumbItem>
                                <a href='/'>Home</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                Argomenti
                            </BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>
            </Container>

            <Container className={'page-title tags-page-title-page pb-5'}>
                <Row>
                    <Col lg="7">
                        <h1>Argomenti</h1>
                        <div className="mt-4">Gli argomenti rispondono a un'esigenza di organizzazione dei contenuti per temi e rappresentano le principali categorie di contenuti, informazioni e documenti.</div>
                    </Col>
                </Row>
            </Container>

            <Container>
                <h2 className="news-page-category-title mb-4 px-1 mt-5">In evidenza</h2>  
            </Container>

            <Container fluid className="sticky-tags-page-section">
                <Container>
                    <GridList className='it-quilted-grid'>
                        <GridRow>
                            <Col md={6} xs={12}>
                            {stickyTags && stickyTags.slice(0, 1).map((stickyTag) =>                                 
                                <GridItem key={"key_stickyTag_" + stickyTag.slug} className='it-grid-item-overlay'>
                                <a href={'/argomenti/' + stickyTag.slug + '/'} className='' data-element="topic-element">
                                    <ResponsiveImage src={env.AUTH_BACKEND_BASE_URL + stickyTag.image} alt={stickyTag.name} title={stickyTag.name} />
                                    <GridItemTextWrapper>
                                        <GridItemText><h3>{stickyTag.name}</h3></GridItemText>
                                    </GridItemTextWrapper>
                                </a>
                                </GridItem>                                
                            )}
                            </Col>
                            
                            <Col md={6} xs={12}>
                                <GridRow>
                                {stickyTags && stickyTags.slice(1, 3).map((stickyTag) =>                                    
                                    <Col xs={6} key={"key_stickyTag_" + stickyTag.slug}>
                                        <GridItem className='it-grid-item-overlay'>
                                        <a href={'/argomenti/' + stickyTag.slug + '/'} className='' data-element="topic-element">
                                        <ResponsiveImage src={env.AUTH_BACKEND_BASE_URL + stickyTag.image} alt={stickyTag.name} title={stickyTag.name} />
                                            <GridItemTextWrapper>
                                                <GridItemText><h3>{stickyTag.name}</h3></GridItemText>
                                            </GridItemTextWrapper>
                                        </a>
                                        </GridItem>
                                    </Col>                  
                                )}

                                {stickyTags && stickyTags.slice(3, 4).map((stickyTag) =>
                                    <Col xs={12} key={"key_stickyTag_" + stickyTag.slug}>
                                        <GridItem className='it-grid-item-overlay it-grid-item-double-w'>
                                        <a href={'/argomenti/' + stickyTag.slug + '/'} className='' data-element="topic-element">
                                        <ResponsiveImage src={env.AUTH_BACKEND_BASE_URL + stickyTag.image} alt={stickyTag.name} title={stickyTag.name} />
                                            <GridItemTextWrapper>
                                                <GridItemText><h3>{stickyTag.name}</h3></GridItemText>
                                            </GridItemTextWrapper>
                                        </a>
                                        </GridItem>
                                    </Col>
                                )}
                                </GridRow>
                            </Col>
                        </GridRow>
                    </GridList>
                </Container>
            </Container>

            <Container>
                <h2 className="news-page-category-title px-1 mt-5">Tutti gli argomenti</h2>  
            </Container>

            <Container className="all-tags-page-section mb-5">
                <WidgetTags widget={widgetTags} />
            </Container>

            <Container fluid className={'rating-wrapper page-rating tags-page-rating'} data-element="feedback">
                <WidgetPageRating page_title={'Argomenti'} />
            </Container>

            <Container fluid className={'contacts-wrapper tags-page-contacts'}>
                <WidgetContacts />
            </Container>

        </Container>       
    </>;
}

export default PageTags;